import { ORM } from './CouchORM2';
import { db, uuid, LexoRank } from '../Database.svelte';

export default class QuestionLibrary extends ORM {
    static modelName = "QuestionLibrary";

    static async importQuestionLibrary(library, data) {
        let headers = data.shift();

        let template_headers = [
            "Category Number",
            "Category Name",
            "Subcategory Number",
            "Subcategory Name",
            "Control Number",
            "Control Title",
            "Control Text",
            "Answer Type",
            "Control Level",
            "Topic Tags",
            "Guidance"
        ]

        if (JSON.stringify(headers.slice(0, 11)) != JSON.stringify(template_headers)) {
            throw new Error ("Invalid Import Template")
        }

        const answer_type_map = {
            'Yes/No': 'yes_no_new',
            'Implementation Status': 'implementation_status_new'
        };

        let current_category;
        let category_child_id;
        let category_rank = library.rank;

        let current_subcategory;
        let subcategory_child_id;
        let subcategory_rank;

        let control;
        let control_child_id;
        let control_rank;

        let docs = [];
        for (let row of data) {
            if (row[0] && row[0] !== current_category?.control_number) {
                category_child_id = uuid();
                current_category = {
                    _id: `${library.id}:categories:_child:${category_child_id}`,
                    child_id: category_child_id,
                    name: row[1],
                    control_number: row[0],
                    rank_: category_rank.toString()
                }

                category_rank = category_rank.genNext();
                docs.push(current_category)
                subcategory_rank = LexoRank.middle()
            }

            if (row[2] && row[2] !== current_subcategory?.control_number) {
                subcategory_child_id = uuid();
                current_subcategory = {
                    _id: `${current_category._id}:subcategories:_child:${subcategory_child_id}`,
                    child_id: subcategory_child_id,
                    name: row[3],
                    control_number: row[2],
                    rank_: subcategory_rank.toString()
                }

                subcategory_rank = subcategory_rank.genNext();
                docs.push(current_subcategory);
                control_rank = LexoRank.middle();
            }

            control_child_id = uuid()
            control = {
                _id: `${current_subcategory._id}:controls:_child:${control_child_id}`,
                child_id: control_child_id,
                control_number: row[4],
                name: row[5],
                text: row[6],
                question_type: answer_type_map[row[7]],
                level: row[8],
                topic_tags: row[9] ? row[9].split(',') : undefined,
                rank_: control_rank.toString(),
                guidance: row[10]
            }
            control_rank = control_rank.genNext();
            docs.push(control);
        }

        return db.bulkDocs(docs);

    }
}